import React from 'react';
import styles from './styles.module.scss';

const AuthInfo: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      {/* Users are strictly prohibited from maintaining multiple accounts, completing offers on behalf of others, or using tools that mask device identity or location, including VPNs, virtual private servers (VPS), or device simulation programs. */}
    </div>
  );
};

export default AuthInfo;
